<template>
    <Field :name="name" v-slot="{ field, errors }" v-bind="fieldValidateOn">
        <Phone
            v-model="field.value"
            v-model:countryCode="country"
            @update:modelValue="field['onUpdate:modelValue']"
            :onBlur="field.onBlur"
            :errorMessages="errors"
            :field-error="!isEmpty(errors)"
            v-bind="input" />
    </Field>
</template>

<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject, ref, watch } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import Phone from './Phone.vue';

    type PhoneProps = ExtractPropTypes<typeof Phone.props>;

    export default defineComponent({
        name: 'PhoneField',
        methods: { isEmpty },
        components: { Field, Phone },
        emits: ['update:countryCode'],
        props: {
            name: { type: String, required: true },
            countryCode: { type: String, required: false },
            input: {
                type: Object as PropType<Partial<PhoneProps>>,
                default: () => ({}),
            },
        },
        setup(props, { emit }) {
            const country = ref<string | undefined>(props.countryCode);

            watch(
                () => country.value,
                (newValue) => {
                    emit('update:countryCode', newValue);
                }
            );

            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;

            return { fieldValidateOn, country };
        },
    });
</script>
